import React, { Fragment, useState, useCallback } from 'react';
import { useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { getInt } from '../../../../utils/functions';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_INCOME_SOURCES } from 'constants/rightsCodes';

import IncomeSourceContainer from './IncomeSourceContainer';

const IncomeItemRoute = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const [title, setTitle] = useState('');
  const id = match.params.id && getInt(match.params.id);

  const onClickClose = () => {
    historyContext.push(`/incomeSources`);
  };

  const onChangeIncomeItemTitle = useCallback(incomeItemTitle => {
    setTitle(incomeItemTitle);
  }, []);

  const onRedirect = useCallback(
    id => {
      historyContext.push(`/incomeSources/${id}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} title={title} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_INCOME_SOURCES}>
        <IncomeSourceContainer id={id} onChangeIncomeItemTitle={onChangeIncomeItemTitle} onRedirect={onRedirect} />
      </PermissionCheck>
    </Fragment>
  );
};

IncomeItemRoute.propTypes = {
  match: PropTypes.object.isRequired,
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(IncomeItemRoute);
